import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, Ticket, BookOpen } from "lucide-react";
import { BuyButton } from "../components/BuyButton";
import { money, useApi, loadFailed } from "../lib/api";

export default function Purchases() {
  const api = useApi();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me/purchases").then((r) => setD(r.data)).catch(loadFailed("your purchases")); }, [api]);
  if (!d) return <div className="min-h-[60vh] grid place-items-center mono-label animate-pulse">Loading…</div>;
  const m = d.membership;
  return (
    <div className="spotlight min-h-screen" data-testid="purchases-page">
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-10 space-y-8">
        <div><span className="mono-label text-yellow-300">My purchases</span><h1 className="mt-2 text-4xl sm:text-5xl font-black tracking-tight">Your passes</h1></div>
        <section className="panel p-6 flex flex-wrap items-center gap-5" data-testid="membership-status">
          <BadgeCheck className={`h-9 w-9 ${m.active ? "text-[#39ff6a]" : "text-zinc-600"}`} />
          <div className="flex-1 min-w-[200px]">
            <p className="font-bold text-lg">Camp membership</p>
            <p className="text-sm text-zinc-400" data-testid="membership-status-text">
              {m.via_role ? "Included with your host/admin role" : m.active ? `Active · renews or ends ${new Date(m.until).toLocaleDateString()}` : `Not active · ${money(m.price)}/month`}
            </p>
          </div>
          {!m.active && <BuyButton kind="membership" price={m.price} label={`Join · ${money(m.price)}/mo`} testId="purchases-join-btn" />}
        </section>
        <section className="panel p-6" data-testid="tickets-list">
          <p className="flex items-center gap-2 font-bold mb-3"><Ticket className="h-4 w-4 text-pink-400" /> Show tickets</p>
          {d.tickets.length === 0 && <p className="text-sm text-zinc-500">No tickets yet.</p>}
          {d.tickets.map((t) => (
            <div key={t.id} className="flex items-center gap-3 py-2 border-b border-[#2d2d38] last:border-0" data-testid={`ticket-${t.item_id}`}>
              <span className="text-[#39ff6a]">✓</span><span className="flex-1">{t.title}</span>
              <span className="mono text-xs text-zinc-400">{t.show ? new Date(t.show.scheduled_at).toLocaleString() : ""}</span>
              {t.show && <Link to={`/room/${t.show.room_id}`} className="text-sm text-yellow-300">Go to room</Link>}
            </div>
          ))}
        </section>
        <section className="panel p-6" data-testid="courses-owned">
          <p className="flex items-center gap-2 font-bold mb-3"><BookOpen className="h-4 w-4 text-yellow-400" /> Courses</p>
          {d.courses.length === 0 && <p className="text-sm text-zinc-500">No courses yet.</p>}
          {d.courses.map((c) => (
            <div key={c.id} className="flex items-center gap-3 py-2 border-b border-[#2d2d38] last:border-0" data-testid={`owned-course-${c.item_id}`}>
              <span className="text-[#39ff6a]">✓</span><span className="flex-1">{c.title}</span><span className="mono text-xs text-zinc-400">{money(c.amount)}</span>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
